module.exports = __webpack_public_path__ + "static/media/38-9.28d78dc7.mp3";